import React, { useState } from "react";
import { backendApi } from "@/api/backendApi";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export default function CreateJob() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: "",
    company: "",
    location: "",
    work_mode: "office",
    experience_min: "",
    experience_max: "",
    salary_min: "",
    salary_max: "",
    skills: "",
    description: "",
  });

  const [loading, setLoading] = useState(false);

  const updateField = (key, value) => setForm({ ...form, [key]: value });

  const submitJob = async () => {
    try {
      setLoading(true);

      const payload = {
        ...form,
        experience_min: form.experience_min ? Number(form.experience_min) : undefined,
        experience_max: form.experience_max ? Number(form.experience_max) : undefined,
        salary_min: form.salary_min ? Number(form.salary_min) : undefined,
        salary_max: form.salary_max ? Number(form.salary_max) : undefined,
        skills: form.skills.split(",").map(s => s.trim()).filter(Boolean),
      };

      await backendApi.entities.Job.create(payload);
      navigate("/recruit/jobs");
    } catch (err) {
      alert(err.message || "Failed to create job");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6 max-w-2xl bg-white p-6 rounded-xl border">
      <h1 className="text-xl font-bold text-slate-900 border-b pb-4">Create New Job Post</h1>

      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <Input placeholder="Job Title *" value={form.title} onChange={(e) => updateField("title", e.target.value)} />
          <Input placeholder="Company Name *" value={form.company} onChange={(e) => updateField("company", e.target.value)} />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <Input placeholder="Location (e.g., Bangalore)" value={form.location} onChange={(e) => updateField("location", e.target.value)} />
          <select
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
            value={form.work_mode}
            onChange={(e) => updateField("work_mode", e.target.value)}
          >
            <option value="office">Office</option>
            <option value="remote">Remote</option>
            <option value="hybrid">Hybrid</option>
          </select>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <Input type="number" placeholder="Min Experience (Years)" value={form.experience_min} onChange={(e) => updateField("experience_min", e.target.value)} />
          <Input type="number" placeholder="Max Experience (Years)" value={form.experience_max} onChange={(e) => updateField("experience_max", e.target.value)} />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <Input type="number" placeholder="Min Salary (LPA)" value={form.salary_min} onChange={(e) => updateField("salary_min", e.target.value)} />
          <Input type="number" placeholder="Max Salary (LPA)" value={form.salary_max} onChange={(e) => updateField("salary_max", e.target.value)} />
        </div>

        <Input placeholder="Skills required (comma separated, e.g., React, Node, AWS)" value={form.skills} onChange={(e) => updateField("skills", e.target.value)} />

        <Textarea
          placeholder="Detailed Job Description"
          className="min-h-[150px]"
          value={form.description}
          onChange={(e) => updateField("description", e.target.value)}
        />
      </div>

      <Button disabled={loading || !form.title || !form.company} className="bg-indigo-600 hover:bg-indigo-700 text-white w-full" onClick={submitJob}>
        {loading ? "Posting Job..." : "Post Job to Portal"}
      </Button>
    </div>
  );
}
